import { render } from "./TodaysCourse.vue?vue&type=template&id=7ef7fafb"
import script from "./TodaysCourse.vue?vue&type=script&lang=js"
export * from "./TodaysCourse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__